module.exports = __webpack_public_path__ + "static/assets/35e90aca7f3862571422223339868c08.svg";